import React, { useState, useEffect } from 'react'
import { BsChevronCompactLeft, BsChevronCompactRight } from 'react-icons/bs';
import { RxDotFilled } from 'react-icons/rx';

import ImageOne from '../assets/render1.png'
import ImageTwo from '../assets/render2.png'
import ImageThree from '../assets/render3.png'

const Gallery = () => {
    const slides = [
        {
            url: ImageOne
        },
        {
            url: ImageTwo
        },
        {
            url: ImageThree

        },
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    const prevSlide = () => {
        const isFirstSlide = currentIndex === 0;
        const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
    };

    const nextSlide = () => {
        const isLastSlide = currentIndex === slides.length - 1;
        const newIndex = isLastSlide ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
    };

    const goToSlide = (slideIndex) => {
        setCurrentIndex(slideIndex);
    };

    useEffect(() => {
        const timer = setTimeout(nextSlide, 10000); // The interval here (e.g., 3000 for 3 seconds)
        return () => clearTimeout(timer); // Clear the timer when the component unmounts
    }, [currentIndex]);


    return (

        <div className='max-w-[900px] h-full w-full py-3 px-4 relative group justify-center object-scale-down'>
            <div style={{ backgroundImage: `url(${slides[currentIndex].url})` }} className='w-full h-full rounded bg-center bg-cover duration-500'>

            </div>



            <div className='hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] left-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer'>
                <BsChevronCompactLeft onClick={prevSlide} size={20} />
            </div>

            <div className='hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] right-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer'>
                <BsChevronCompactRight onClick={nextSlide} size={20} />
            </div>
            <div className='flex top-4 justify-center py-2'>
                {slides.map((slide, slideIndex) => (
                    <div
                        key={slideIndex}
                        onClick={() => goToSlide(slideIndex)}
                        className='text-2xl cursor-pointer'                    >
                        <RxDotFilled style={{ color: 'gray' }} />
                    </div>
                ))}
            </div>

        </div >
    )
}

export default Gallery
